import request from "@/utils/request";
import { apiConfig } from "../config/api";

// 项目概况
export function statistics() {
  return request({
    url: apiConfig.statistics.api.statistics.url,
    method: "get"
  });
}

export function user(req) {
  return request({
    url: apiConfig.statistics.api.user.url,
    method: "post",
    data: {
      startDate: req.startDate,
      endDate: req.endDate
    }
  });
}
export function hasCertificateUser(req) {
  return request({
    url: apiConfig.statistics.api.hasCertificateUser.url,
    method: "post",
    data: {
      startDate: req.startDate,
      endDate: req.endDate
    }
  });
}
